function convertPriceCommaToDot(commaPrice: string): string {
  return commaPrice.replace(/,/g, '.');
}

export default convertPriceCommaToDot;
